/**
 * Checks if the Shopify cookie/consent banner (#shopify-pc__banner) is visible
 * and syncs the body lock by adding or removing the is-locked class on html.
 */
function updateBodyLockForCookieBanner() {
  const banner = document.querySelector('#shopify-pc__banner');
  const isVisible = banner && banner.offsetHeight > 0 && window.getComputedStyle(banner).display !== 'none';
  const pageOverlay = document.querySelector('.pageOverlay');
  if (isVisible) {
    pageOverlay?.classList.add('is-visible');
  } else {
    pageOverlay?.classList.remove('is-visible');
  }
}

function initCookieBannerBodyLock() {
  updateBodyLockForCookieBanner();
  const bodyObserver = new MutationObserver(() => {
    updateBodyLockForCookieBanner();
    const banner = document.querySelector('#shopify-pc__banner');
    if (banner && !banner._bodyLockObserved) {
      banner._bodyLockObserved = true;
      const bannerObserver = new MutationObserver(updateBodyLockForCookieBanner);
      bannerObserver.observe(banner, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:consent:updated', updateBodyLockForCookieBanner);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookieBannerBodyLock);
} else {
  initCookieBannerBodyLock();
}
